import React from "react";
import { connect } from "react-redux";
import { Routes, Route, Navigate } from "react-router-dom";
import {
  ConfirmItDashboard, Contact, EditOrderFulfillment,
  ExchangeOrder, FAQ, Home, LoginPartner, Order,
  ReturnOrder, ScratchExchangeOrder, ScratchOrder, ScratchReturnOrder,
  Notifications, ReturnsSystemHome, SuscribeFLow,
  ManageProducts, ReturnRequests, ExchangeRequests, ReturnRequest, ExchangeRequest,
  DuplicateOrder, TermsAndConditions, BazaarsList, CreateBazaar,
  BazaarDetail, BazaarsComingSoon, Pulse
} from "./Pages";
import ProtectedRoute from "./ProtectedRoute";
import { bazaarsEnabled } from "./app/config/featureFlags";
import AppShell from "./app/glass/AppShell";
import PublicShell from "./app/glass/PublicShell";
import InventoryPage from "./Pages/InventoryPage";
import SettingsPage from "./Pages/SettingsPage";
import SupportPage from "./Pages/SupportPage";
import FinancePage from "./Pages/FinancePage";
import OrdersHub from "./Pages/OrdersHub";

const PublicPage = ({ children }) => <PublicShell>{children}</PublicShell>;

export const Router = () => {
  return (
    <Routes>
      <Route path="/login" element={<PublicPage><LoginPartner /></PublicPage>} />
      <Route path="/terms-and-conditions" element={<PublicPage><TermsAndConditions /></PublicPage>} />
      <Route path="/faq" element={<PublicPage><FAQ /></PublicPage>} />
      <Route path="/faqs" element={<PublicPage><FAQ /></PublicPage>} />
      <Route path="/contact" element={<PublicPage><Contact /></PublicPage>} />

      <Route element={<ProtectedRoute allowed={["Partner"]} />}>
        <Route element={<AppShell />}>
          <Route path="/" element={<Home />} />
          <Route path="/inventory" element={<InventoryPage />} />
          <Route path="/products" element={<Navigate to="/inventory" replace />} />
          <Route path="/inventory/send" element={<Navigate to="/inventory?tab=send" replace />} />
          <Route path="/inventory/history" element={<Navigate to="/inventory?tab=history" replace />} />

          <Route path="/orders" element={<OrdersHub />} />
          <Route path="/returns" element={<Navigate to="/orders?tab=returns" replace />} />
          <Route path="/exchanges" element={<Navigate to="/orders?tab=exchanges" replace />} />
          <Route path="/orders/:id" element={<Order />} />
          <Route path="/orders/return/:id" element={<ReturnOrder />} />
          <Route path="/orders/exchange/:id" element={<ExchangeOrder />} />
          <Route path="/orders/duplicate/:id" element={<DuplicateOrder />} />
          <Route path="/orders/fulfillment/:id" element={<EditOrderFulfillment />} />
          <Route path="/external-exchange" element={<ScratchExchangeOrder />} />
          <Route path="/external-return" element={<ScratchReturnOrder />} />
          <Route path="/external-order" element={<ScratchOrder />} />

          <Route path="/finance" element={<FinancePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/profile" element={<Navigate to="/settings?tab=user" replace />} />
          <Route path="/keys" element={<Navigate to="/settings?tab=shopify" replace />} />

          <Route path="/support" element={<SupportPage />} />
          <Route path="/help-desk" element={<Navigate to="/support?tab=help" replace />} />
          <Route path="/action-center" element={<Navigate to="/support?tab=action" replace />} />

          <Route path="/notifications" element={<Notifications />} />
          <Route path="/pulse" element={<Pulse />} />
          <Route path="/confirmit-dashboard" element={<ConfirmItDashboard />} />

          {bazaarsEnabled ? (
            <>
              <Route path="/bazaars" element={<BazaarsList />} />
              <Route path="/bazaars/create" element={<CreateBazaar />} />
              <Route path="/bazaars/:id/edit" element={<CreateBazaar />} />
              <Route path="/bazaars/:id" element={<BazaarDetail />} />
            </>
          ) : (
            <>
              <Route path="/bazaars" element={<BazaarsComingSoon />} />
              <Route path="/bazaars/*" element={<BazaarsComingSoon />} />
            </>
          )}

          <Route path="/returns-system" element={<ReturnsSystemHome />} />
          <Route path="/returns-system/subscribe" element={<SuscribeFLow />} />
          <Route path="/returns-system/manage-products" element={<ManageProducts />} />
          <Route path="/returns-system/return-requests" element={<ReturnRequests />} />
          <Route path="/returns-system/exchange-requests" element={<ExchangeRequests />} />
          <Route path="/returns-system/return-requests/:id" element={<ReturnRequest />} />
          <Route path="/returns-system/exchange-requests/:id" element={<ExchangeRequest />} />
        </Route>
      </Route>
    </Routes>
  );
};

const mapStateToProps = () => ({});
export default connect(mapStateToProps, {})(Router);
